import React from 'react';
import Ribbon from '@widgets/ribbon';
import './splashScreen.scss';
import RibbonSeparator, { RibbonSeparatorGtc } from '@widgets/ribbon/ribbonSeparator';
function RibbonFlip() {
    return (React.createElement("div", { className: "ltg-splash-screen" },
        React.createElement("div", null,
            React.createElement("div", { className: "ribbon-wrap" },
                React.createElement("div", { className: 'ribbon' },
                    React.createElement(Ribbon, { side: 'left' })),
                React.createElement("div", { className: "ribbon" },
                    React.createElement(Ribbon, { side: 'right', color: 'primary' }))))));
}
function DotTravel() {
    return React.createElement("div", { className: "ltg-splash-screen-dot" },
        React.createElement(RibbonSeparatorGtc, null));
}
function Pattern() {
    return React.createElement("div", { className: "ltg-splash-screen ltg-splash-screen-pattern" },
        React.createElement("div", null,
            React.createElement(RibbonSeparator, null),
            React.createElement(RibbonSeparator, null)));
}
let SplashScreen = RibbonFlip;
switch (THEME) {
    case ('gtc'):
        SplashScreen = DotTravel;
        break;
    case ('museum'):
        SplashScreen = Pattern;
        break;
}
export { SplashScreen };
